var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFergusonProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#066b95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#064d7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06347a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.29657,50.91779c0,2.75928-2.25513,4.99695-5.04633,4.99695v4.99695c5.5824,0,10.09869-4.47455,10.09869-9.99396l-5.05237.00006Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.18793,70.90521c0-2.76007,2.27106-4.99695,5.06226-4.99695v-4.99695c-5.5824,0-10.11847,4.47455-10.11847,9.99396l5.05621-.00006Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.25,55.90723v-4.93396c-5.57098,0-10.08124,4.46545-10.08124,9.97192,0,.39862.02429.7912.06982,1.17694l5.10022-.00006c-.09717-.38721-.14801-.79114-.14801-1.20728,0-2.76538,2.26196-5.00757,5.0592-5.00757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.34277,60.94519c0-.42902-.02734-.83752-.08051-1.25287h-5.0896c.09717.38721.1488.8056.1488,1.22247,0,2.76538-2.27411,5.00763-5.07135,5.00763l-.00006,4.99542c5.57104,0,10.09271-4.46466,10.09271-9.97266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.94421,36.81464l-5.6098-3.23877-18.48682,10.67346,6.79388,3.9223c.36639.21155.81787.21155,1.18433,0l16.11835-9.30554c.78961-.45587.78961-1.59558.00006-2.05145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.5235,38.86615l5.13184,2.96277,18.48712-10.67334-6.31641-3.64673c-.36646-.21155-.81793-.21155-1.18433,0l-16.11823,9.30585c-.78961.45587-.78961,1.59558,0,2.05145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.65106,43.46454v18.68835c0,.41125.21936.7912.5755.99683l16.18445,9.34412c.7674.44305,1.72656-.11072,1.72656-.99683v-18.68817c0-.41119-.21936-.7912-.5755-.99677l-6.87177-3.96753v9.87964l-4.19208-2.17682v-10.12317l-5.12067-2.95642c-.76733-.44305-1.7265.11072-1.7265.99677Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFergusonProductsScraper);
export default __webpack_public_path__ + "static/media/ferguson-products-scraper.9dd0339a069856342bb3f472170668d9.svg";
export { ForwardRef as ReactComponent };